import MUIInputLabel from '@mui/material/InputLabel';

type InputLabelProps = {
  children?: React.ReactNode;
  id?: string;
  props?: any;
};

export default function InputLabel({
  children,
  id,
  ...props
}: Readonly<InputLabelProps>) {
  return (
    <MUIInputLabel id={id} {...props}>
      {children}
    </MUIInputLabel>
  );
}
